import * as types from '@/store/mutation-types'

const state = {
  storeLocations: [],
  activeLocation: {}
}

export const getters = {
  storeLocations: state => {
    const activeLocationId = state.activeLocation.id
    if (activeLocationId === undefined) {
      return state.storeLocations
    } else {
      return state.storeLocations.filter(location => location.id !== activeLocationId)
    }
  },
  activeLocation: state => state.activeLocation
}

export const actions = {
  setStoreLocations ({ commit }, storeLocations) {
    commit(types.SET_STORE_LOCATIONS, storeLocations)
  },
  setActiveLocation ({ commit }, location) {
    commit(types.SET_ACTIVE_LOCATION, location)
  }
}

export const mutations = {
  [types.SET_STORE_LOCATIONS] (state, storeLocations) {
    state.storeLocations = storeLocations
  },
  [types.SET_ACTIVE_LOCATION] (state, location) {
    state.activeLocation = location
    localStorage.setItem('activeLocation', JSON.stringify(location))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
